<script lang="ts">
export default {
  name: 'PageSpinner',
  inheritAttrs: false,
};
</script>

<script setup lang="ts">
import Spinner from '@/components/v2/Spinner.vue';
</script>

<template>
  <div
    class="grid place-content-center place-items-center h-[50vh]"
    v-bind="$attrs">
    <Spinner size="lg" />
  </div>
</template>
